// extracted by mini-css-extract-plugin
export default {"container":"signature_container__qcvoX","box":"signature_box__I0-jG","closeButton":"signature_closeButton__JhTWe","button":"signature_button__BH+z-"};